import useReveal from './useReveal';

const values = [
  { title: 'Precision', desc: 'Technical accuracy and attention to detail on every project.' },
  { title: 'Efficiency', desc: 'Timely delivery and resource optimisation without compromise.' },
  { title: 'Alignment', desc: 'Transparent communication and collaboration with all stakeholders.' },
  { title: 'Quality', desc: 'Full compliance with safety protocols and regulatory standards.' },
];

export default function About() {
  const ref = useReveal();

  return (
    <section id="about">
      <div className="about-grid reveal" ref={ref}>
        <div className="about-left">
          <div className="corner" />
          <div className="about-img">
            <div className="about-img-fill">
              <div className="alogo">
                <svg viewBox="0 0 48 48" fill="white">
                  <path d="M24 6C14.06 6 6 14.06 6 24s8.06 18 18 18 18-8.06 18-18S33.94 6 24 6zm0 3c8.28 0 15 6.72 15 15S32.28 39 24 39 9 32.28 9 24 15.72 9 24 9zm-5 8v3h3.5v9H19V31h10v-3h-3.5V17H19z" />
                </svg>
              </div>
              <p>FM Maepa Engineering</p>
            </div>
          </div>
          <div className="est-badge">
            <span className="yr">2015</span>
            <span className="yl">Est.</span>
          </div>
        </div>

        <div className="about-right">
          <div className="eyebrow">Who We Are</div>
          <h2 className="sec-title">A Multidisciplinary<br />Engineering Firm</h2>
          <p style={{ marginTop: 28 }}>
            Established in 2015, F.M Maepa Engineering is a proudly South African, multidisciplinary
            company providing specialized engineering and transport services.
          </p>
          <p>
            As a division of F.M Maepa (Pty) Ltd, we bring over a decade of experience delivering
            tailored solutions to the mining, civil, and industrial sectors.
          </p>
          <p>
            Our purpose is to deliver integrated, high-impact solutions that merge technical excellence,
            strategic project management, and a deep commitment to quality — ensuring our services adapt
            to the evolving needs of our clients.
          </p>
          <div className="values-grid">
            {values.map(v => (
              <div className="val-card" key={v.title}>
                <h4>{v.title}</h4>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
